import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui-Standard: Klassen zusammenfuehren, Tailwind-Konflikte aufloesen. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
